<template>
  <basic-container id="withdrawal-setting20220520">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="searchForm"
      :permission="permissionList"
      :before-open="beforeOpen"
      :before-close="beforeClose"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="payTimeSearch">
        <el-date-picker
          v-model="searchForm.payTimeCopy"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          align="right"
        >
        </el-date-picker>
      </template>
      <template slot="createTimeSearch">
        <el-date-picker
          v-model="searchForm.createTimeCopy"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          align="right"
        >
        </el-date-picker>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" icon="el-cion-view" @click="openDialog(scope.row)">查看</el-button>
      </template>
      <template slot="transferFee" slot-scope="scope">
        {{ tool.money_format(scope.row.transferFee) }}
      </template>
      <template slot="counterFee" slot-scope="scope">
        {{ tool.money_format(scope.row.counterFee) }}
      </template>
      <template slot="enterFee" slot-scope="scope">
        {{ tool.money_format(scope.row.enterFee) }}
      </template>

      <template slot="accountId" slot-scope="scope">
        <wq-overHidden :content="scope.row.$accountId">
          <span>{{ scope.row.$accountId }}</span>
        </wq-overHidden>
      </template>
      <template slot="approverDescription" slot-scope="scope">
        <wq-overHidden :content="scope.row.approverDescription">
          <span>{{ scope.row.approverDescription }}</span>
        </wq-overHidden>
      </template>
      <template slot="remark" slot-scope="scope">
        <wq-overHidden :content="scope.row.remark">
          <span>{{ scope.row.remark }}</span>
        </wq-overHidden>
      </template>
    </avue-crud>
    <ViewDialog ref="ViewDialog"></ViewDialog>
  </basic-container>
</template>

<script>
import { gettransferApplyList as getList, getFeePayList } from '@/api/v4ward/carv2/financial.js';
import { mapGetters } from 'vuex';
import ViewDialog from './viewDialog.vue';
export default {
  components: { ViewDialog },
  data() {
    return {
      form: {
        attachIdList: [],
      },
      searchForm: {
        payTimeCopy: '',
        createTimeCopy: '',
      },
      query: {},
      loading: false,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 350,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        searchMenuSpan: 24,
        selection: false,
        stripe: true,
        editBtn: false,
        delBtn: false,
        menuWidth: 100,
        dialogClickModal: false,
        dialogWidth: '50%',
        labelWidth: 140,
        menu: true,
        addBtn: false,
        column: [
          {
            prop: 'transferNo',
            label: '提现单号',
          },
          {
            label: '提现金额',
            prop: 'transferFee',
            align: 'right',
            slot: true,
          },
          {
            label: '手续费',
            prop: 'counterFee',
            align: 'right',
            slot: true,
          },
          {
            label: '到账金额',
            prop: 'enterFee',
            align: 'right',
            slot: true,
          },
          {
            label: '提现人',
            prop: 'transferPerson',
          },
          {
            label: '提现账号',
            prop: 'transferAccount',
          },
          {
            label: '操作人',
            prop: 'applyPerson',
          },
          {
            label: '申请时间',
            prop: 'createTime',
            search: true,
            searchSpan: 12,
            display: false,
            searchslot: true,
          },
          {
            label: '提现状态',
            prop: 'status',
            type: 'select',
            dataType: 'string',
            display: false,
            dicUrl: '/api/blade-system/dict/dictionary?code=transfer_fee_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请选择提现状态',
                trigger: 'change',
              },
            ],
          },
          {
            label: '付款类型',
            prop: 'payType',
          },
          {
            label: '付款时间',
            prop: 'payTime',
            search: true,
            searchSpan: 12,
            display: false,
            searchslot: true,
          },
          {
            label: '申请原因',
            prop: 'remark',
            type: 'input',
            slot: true,
          },
        ],
      },
      data: [],
      passCloseDialog: false,
      temProjectId: '',
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        // addBtn: this.vaildData(this.permission.withdrawal_setting_add, false),
        viewBtn: this.vaildData(this.permission.withdrawal_setting_view, false),
        // delBtn: this.vaildData(this.permission.withdrawal_setting_delete, false),
        // editBtn: this.vaildData(this.permission.withdrawal_setting_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    // this.initData();
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.crud.$children[1].$children[2].$el.addEventListener('click', () => {
          if (this.option.height == this.bodyHeight - 338) {
            this.option.height = this.bodyHeight - 274;
          } else {
            this.option.height = this.bodyHeight - 338;
          }
          this.$refs.crud.getTableHeight();
        });
      });
    });
    this.option.height = this.bodyHeight - 338;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$refs.crud.$refs.table.doLayout();
    });
  },
  methods: {
    openDialog(row) {
      this.$refs.ViewDialog.openDialog(row);
    },
    searchReset() {
      this.query = {};
      this.searchForm = {};
      this.searchForm.projectId = this.temProjectId;
      this.query.projectId = this.temProjectId;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      if (this.query.payTimeCopy) {
        this.query.searchStartPayTime = this.dayjs(this.query.payTimeCopy[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        this.query.searchEndPayTime = this.dayjs(this.query.payTimeCopy[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
      }
      if (this.query.createTimeCopy) {
        this.query.applyTimeStart = this.dayjs(this.query.createTimeCopy[0]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
        this.query.applyTimeEnd = this.dayjs(this.query.createTimeCopy[1]).format(
          'YYYY-MM-DD HH:mm:ss'
        );
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style>
#withdrawal-setting20220520 .avue-form__menu--center {
  text-align: right;
}
</style>
<style scoped>
::v-deep .avue-form__menu--center {
  text-align: right;
}
::v-deep .avue-crud__search .el-form-item--small.el-form-item {
  width: 100%;
}
</style>
